export const parseDocStatus = (score: number) => {
  if (score <= 65) return "Rejected";
  if (score <= 70) return "Warning";
  if (score > 70) return "Accepted";
};
